import { PersonenstandEnum } from '../v2024';

export const PersonenstandEnumLabels = {
    _002: '002' as PersonenstandEnum,
    _003: '003' as PersonenstandEnum,
    _004: '004' as PersonenstandEnum,
    _005: '005' as PersonenstandEnum
};

